<template>
  <div
    ref="scrollable"
    class="dashboard-page-wrapper test-page dm-cvd-test"
    tabindex="0"
    @keydown="handleKeyDown"
  >
    <div class="top-wrap">
      <div class="text-img">
        <h2> Constant Volume Depletion </h2>
        <div v-if="receivedData">
          <div v-if="pdfLoader === true" class="test-pdf-div">
            <div class="img-content">
            <img :src="pdf_loader_image" alt="loader Image" />
            </div>
          </div>
          <div v-else-if="receivedData.testID !== ''" @click="goToPdf()" class="test-pdf-div">
            <div class="img-content">
            <img :src="pdf_icon" alt="pdf icon" />
            </div>
          </div>
        </div>
      </div>
      <div class="top-content" v-if="receivedData && receivedData.cvdTestProperties">
        <v-img
          src="../../../assets/Images/Assets/top image.png"
          alt="test image"
          width="49px"
          height="49px"
        ></v-img>
        <div class="fields-info">
          <div class="fields-info-wrap">
            <template v-for="(item, index) in receivedData.cvdTestProperties" :key="item.originalKey">
              <div v-if="item.value" class="field-item">
                <p class="field-item-label">{{ item.displayName }}</p>
                <p class="test-top-values">
                  <v-tooltip location="top" content-class="test-top-value-tooltip">
                    <template v-slot:activator="{ props }">
                      <span v-bind="props" v-if="typeof item.value === 'number'" class="value-text">
                        {{ item.digits > 0 ? item.value.toFixed(item.digits) : item.value }}
                      </span>
                      <span v-bind="props" v-else class="value-text">
                        {{ item.value }}
                      </span>
                    </template>
                    <span>{{ item.value }}</span>
                  </v-tooltip>
                  <span v-if="item.unit">&nbsp;{{ item.unit }}</span>
                </p>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="top-content" v-else>
        <test-loaders />
      </div>
    </div>
    <div class="tabs-data">
      <div class="tabs-toggle">
        <v-tabs v-model="tab">
          <v-tab value="one">Cvd Test Properties</v-tab>
          <v-tab value="two">Evolved Gas Compositions</v-tab>
          <v-tab value="three">Last Stage Liquid Compositions</v-tab>
        </v-tabs>

        <div v-if="tab === 'three'">
          <v-btn-toggle v-model="toggleFractionParent" mandatory
            class="elevation-0 axis-toggle" @update:modelValue="handleToggleChange">
            <v-btn :value="true" class="switch-btn text-none text-caption">wt%</v-btn>
            <v-btn :value="false" class="switch-btn text-none text-caption">mol%</v-btn>
          </v-btn-toggle>
        </div>
      </div>



      <v-card-text class="pa-0 pt-4">
        <v-window v-model="tab">
          <v-window-item value="one">
            <CvdTestProperties @data-updated="handleDataUpdate" />
          </v-window-item>

          <v-window-item value="two">
            <ProducedGasCompositions @data-updated="handleDataUpdate" />
          </v-window-item>

          <v-window-item value="three">
            <LastStageLiquidCompositions @data-updated="handleDataUpdate" @toggle-fraction="updateToggleFractionComp" ref="lastStageLiquidCompositions" />
          </v-window-item>
        </v-window>
      </v-card-text>
    </div>
    <v-snackbar v-model="snackbarMessage" color="#E53535" timeout="3000" v-if="snackbarMessage != null">
      Error : {{ snackbarMessage }}
    </v-snackbar>
    <!-- <Filters @drawerStateChanged="handleRightDrawerStateChange" /> -->
  </div>
</template>

<script>
import CvdTestProperties from "./CvdTestProperties.vue";
import CvdGasProperties from "./CvdGasProperties.vue";
import TestLoaders from '../Loaders/TestLoaders.vue';
import ProducedGasCompositions from './ProducedGasCompositions.vue';
import LastStageLiquidCompositions from './LastStageLiquidCompositions.vue';
import axios from "axios";
import { executeSampleReportDownload } from "../../../utils/sampleReportDownload";
import { getTenantPrefixFromRoute } from "@/utils/tenant";
export default {
  components: { CvdTestProperties, CvdGasProperties, TestLoaders, ProducedGasCompositions, LastStageLiquidCompositions, },
  name: "CvdTabs",
  data: () => ({
    toggleFractionParent: true,
    tab: null,
    receivedData: null,
    assetName: "",
    fieldName: "",
    wellName: "",
    pdf_icon: require("../../../assets/Images/pdfIcon.svg"),
    pdf_loader_image: require("../../../assets/Images/pdfLoader.gif"),
    pdfLoader: false,
    snackbarMessage: null,
  }),
  methods: {
    handleDataUpdate(data) {
      if (!this.receivedData?.headers?.length && data?.headers?.length) {
        this.receivedData = data;
      }
    },
    updateToggleFractionComp(value) {
      this.toggleFractionParent = value; // Update the parent state when child emits an event
    },
    handleToggleChange() {
      this.$refs.lastStageLiquidCompositions.toggleFraction = this.toggleFractionParent; // Sync state with the child
      this.$refs.lastStageLiquidCompositions.toggleFractionFunction(); // Call the child's 
    },
    async goToPdf() {
      this.snackbarMessage = null;
      this.pdfLoader = true;
      try {
        const tenantId = getTenantPrefixFromRoute(this.$route) || "";
        const sampleId = this.$route.params.sampleId;
        const result = await executeSampleReportDownload({
          extension: "pdf",
          httpGet: () =>
            axios.get(
              process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}/download`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                  "X-TenantID": tenantId,
                },
                responseType: "blob",
              }
            ),
        });
        if (!result.ok && !result.limitModal && result.snackbarMessage) {
          this.snackbarMessage = result.snackbarMessage;
        }
      } finally {
        this.pdfLoader = false;
      }
    },
    handleKeyDown(event) {
      const key = event.key;
      if (key === 'ArrowDown') {
        this.$refs.scrollable.scrollTop += 50; // You can adjust the scrolling speed as needed
      } else if (key === 'ArrowLeft') {
        const currentIndex = this.tab ? ['one', 'two', 'three'].indexOf(this.tab) : 0;
        this.tab = currentIndex === 0 ? 'three' : ['one', 'two', 'three'][currentIndex - 1];
      } else if (key === 'ArrowRight') {
        const currentIndex = this.tab ? ['one', 'two', 'three'].indexOf(this.tab) : 0;
        this.tab = currentIndex === 2 ? 'one' : ['one', 'two', 'three'][currentIndex + 1];
      }
    },
  },
  mounted() {
    this.tab = 'one';
    this.assetName = this.$route.params.asset.replace(/-/g, ' ');
    this.fieldName = this.$route.params.field.replace(/-/g, ' ');
    this.wellName = this.$route.params.well;
    this.$refs.scrollable.focus();
  },
};
</script>